// Pill-shaped overflow affordance shared by the vertical per-column hint and the
// horizontal category-grid hint, so they look and behave identically. Renders a
// directional arrow next to a label, fades in only when scrolling is possible in
// that direction, and leaves the tab order / a11y tree when inactive.
import { ButtonBase } from '@mui/material';

const ARROWS = {
  up: '↑', down: '↓', left: '←', right: '→',
};

const ScrollAffordanceChip = ({
  direction, visible, label, onClick, sx,
}) => {
  const arrow = ARROWS[direction];
  const content = direction === 'left' ? `${arrow} ${label}` : `${label} ${arrow}`;
  return (
    <ButtonBase
      onClick={onClick}
      aria-label={label}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        fontWeight: 600,
        fontSize: '0.72rem',
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        boxShadow: (t) => (t.palette.mode === 'dark'
          ? '0 6px 16px -6px rgba(0,0,0,0.7)'
          : '0 6px 16px -6px rgba(15,23,42,0.35)'),
        whiteSpace: 'nowrap',
        zIndex: 2,
        transition: 'opacity 0.2s',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        ...sx,
      }}
    >
      {content}
    </ButtonBase>
  );
};

export default ScrollAffordanceChip;
